/**
 * @module @yimoka/i18n/bundled/merge
 * @summary 深度合并 locale 与 namespace 回退
 * @author keep
 * @since 2026-05-19
 */

import { isVacuous, mergeWithArrayOverride } from '@yimoka/shared';

import type { BundledRegistry } from './registry';

/**
 * 深度合并远程与本地 locale 对象（远程同键覆盖，本地补缺失键）。
 *
 * @param local - 本地 bundled
 * @param remote - 远程 payload
 * @returns 合并结果
 */
export function deepMergeLocale(
  local: Record<string, unknown>,
  remote: Record<string, unknown>,
): Record<string, unknown> {
  return mergeWithArrayOverride({ ...local }, remote) as Record<string, unknown>;
}

/**
 * 解析 namespace：远程与 bundled 合并，非默认语种空 namespace 回退默认语种。
 *
 * @param registry - bundled 注册表
 * @param lang - i18next 短码
 * @param ns - namespace 名
 * @param remoteData - 远程 namespace 数据
 * @returns 合并后的 namespace 文案表
 */
export function resolveNamespaceWithFallback(
  registry: BundledRegistry,
  lang: string,
  ns: string,
  remoteData: Record<string, unknown>,
): Record<string, unknown> {
  const bundled = registry.getNamespace(lang, ns);
  if (isVacuous(bundled)) {
    return remoteData;
  }
  return deepMergeLocale(bundled, remoteData);
}
